import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';

export const WelcomePage = () => {
  const { isAuthenticated } = useAuth();
  return <Navigate to={isAuthenticated ? '/dashboard' : '/signin'} />;
};
